// extracted by mini-css-extract-plugin
export var alignBaseline = "_b-9";
export var alignCenter = "_b-5";
export var alignFlexEnd = "_b-7";
export var alignFlexStart = "_b-6";
export var alignSelfBaseline = "_b-e";
export var alignSelfCenter = "_b-a";
export var alignSelfFlexEnd = "_b-c";
export var alignSelfFlexStart = "_b-b";
export var alignSelfStretch = "_b-d";
export var alignStretch = "_b-8";
export var column = "_b-2";
export var columnReverse = "_b-4";
export var flex = "_b-0";
export var justifyCenter = "_b-f";
export var justifyFlexEnd = "_b-h";
export var justifyFlexStart = "_b-g";
export var justifySpaceAround = "_b-j";
export var justifySpaceBetween = "_b-i";
export var justifySpaceEvenly = "_b-k";
export var row = "_b-1";
export var rowReverse = "_b-3";
export var wrapNowrap = "_b-m";
export var wrapWrap = "_b-l";
export var wrapWrapReverse = "_b-n";